module.exports = __webpack_public_path__ + "img/goal01_over.d1873d9b.png";